import React, { useState, useEffect } from 'react'
import { CloseCircleOutlined, RedoOutlined } from '@ant-design/icons'
import { v4 as uuidv4 } from 'uuid'
import { getPicture, reqCheck } from '@/api/captcha'
import { aesEncrypt } from '@/utils'
import './style.scss'

const defaultImg = ''

const Verify = ({ show, onSuccess, onClose }) => {

  const [captchaType] = useState('clickWord')
  const [secretKey, setSecretKey] = useState('')
  const [token, setToken] = useState('')
  const [wordList, setWordList] = useState([])
  const [pointBackImgBase, setPointBackImgBase] = useState('')
  const [tempPoints, setTempPoints] = useState([])
  const [bindingClick, setBindingClick] = useState(true)
  const [errTip, setErrTip] = useState('')

  // 初始话 uuid 
  const uuid = () => {
    const point = `point-${uuidv4().replaceAll('-', '')}`
    if (!localStorage.getItem('point')) {
      localStorage.setItem("point", point)
    }
  }

  // 刷新
  const handleRefresh = () => {
    getData()
    setTempPoints([])
  }

  // 初始化数据
  const getData = async () => {
    try {
      const res = await getPicture({ captchaType: captchaType, clientUid: localStorage.getItem('point'), ts: Date.now() })
      if (res.code === 0) {
        setPointBackImgBase(res.data.originalImageBase64)
        setSecretKey(res.data.secretKey)
        setToken(res.data.token)
        setWordList(res.data.wordList)
        setErrTip('')
      } else {
        setPointBackImgBase(null)
        setSecretKey('')
        setToken('')
        setWordList([])
        setErrTip('验证码获取失败,请重试')
      }
    } catch (e) {
      console.log(e)
    }
  }

  const check = async () => {
    try {
      const res = await reqCheck({
        captchaType: captchaType,
        pointJson: secretKey ? aesEncrypt(JSON.stringify(tempPoints), secretKey) : JSON.stringify(tempPoints),
        token: token,
        clientUid: localStorage.getItem('point'),
        ts: Date.now()
      })
      if (res.code === 0) {
        setErrTip('')
        onSuccess(res.data)
      } else {
        setErrTip('验证码校验失败,请重试')
        setTimeout(() => {
          handleRefresh()
        }, 1000)
      }
    } catch (e) {
      console.log(e)
    }
  }

  const canvasClick = async (e) => {
    if (bindingClick) {
      setTempPoints((pre) => {
        const tmp = [...pre]
        tmp.push(getMousePos(e))
        return tmp
      })
    }
  }

  //获取坐标
  const getMousePos = (e) => {
    var x = e.nativeEvent.offsetX
    var y = e.nativeEvent.offsetY
    return { x, y }
  }

  useEffect(() => {
    if (show) {
      uuid()
      getData()
    }
  }, [show])

  useEffect(() => {
    setBindingClick(tempPoints.length < wordList.length)
    if (wordList.length > 0 && tempPoints.length === wordList.length) {
      check()
    }
  }, [tempPoints, wordList])

  return (
    <div className='verifybox'>
      <div className='verifybox-top'>
        <div>请在下图依次点击：</div>
        <div className='words'>{wordList ? `【${wordList.join('、')}】` : ''}</div>
      </div>
      <div className='verifybox-bottom'>
        <div className='verify-img-out'>
          <div className='verify-img-panel'>
            {
              pointBackImgBase
                ? <img
                    src={`data:image/png;base64,${pointBackImgBase}`}
                    alt=""
                    onClick={(e) => canvasClick(e)}
                  />
                : <img
                    src={defaultImg}
                    alt=""
                  />
            }
            {
              tempPoints.map((tempPoint, index) => {
                return (
                  <div
                    key={index}
                    className="point-area"
                    style={{
                      left: `${tempPoint.x}px`,
                      top: `${tempPoint.y}px`
                    }}
                  >{index + 1}</div>
                )
              })
            }
          </div>
        </div>
        <div className='verify-bar-area'>
          <div className='btns'>
            <div className='btn close-btn' onClick={ onClose }>
              <CloseCircleOutlined />
            </div>
            <div className='btn refresh-btn' onClick={ handleRefresh }>
              <RedoOutlined />
            </div>
          </div>
          <span className='verify-msg'>
            {errTip}
          </span>
        </div>
      </div>
    </div>
  )
}

export default Verify
